import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-text", "data-url"]

import { onMounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TwShareButton',
  props: {
    url: {},
    text: { default: '' }
  },
  setup(__props: any) {



onMounted(() => {
  setTimeout(() => {
    const twttr = (window as any).twttr
    if (twttr) {
      twttr.widgets.load()
    }
  }, 1000)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("a", {
      class: "twitter-share-button",
      href: "https://twitter.com/intent/tweet",
      "data-size": "small",
      "data-text": __props.text,
      "data-url": __props.url,
      "data-hashtags": "edbase",
      "data-related": "twitterapi,twitter"
    }, " Tweet ", 8 /* PROPS */, _hoisted_1)
  ]))
}
}

})